import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../components-v2/Theme/theme';

const { spacing, common, colors } = THEME;

export const styleSheet = StyleSheet.create({
	settingsContainer: {
		width: '100%',
		flexGrow: 1,
		paddingTop: spacing.md,
		height: '100%',
		boxSizing: 'border-box',
	},
	title: {
		fontSize: 20,
		color: colors.text.main,
		marginBottom: spacing.md,
	},
	subtitle: {
		fontSize: 14,
		color: colors.text.light,
		marginBottom: spacing.md,
	},
	tabRoot: {
		display: 'grid',
		gridTemplateColumns: '250px 1fr',
		gap: spacing.md,
		height: '100%',
	},
	tabListContainer: {},
	tabList: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		alignItems: 'center',
		gap: spacing.sm,
		paddingTop: spacing.sm,
	},
	tabTrigger: {
		width: '100%',
		height: 42,
		borderRadius: common.borderRadius,
		padding: `${spacing.sm}px ${spacing.md}px`,
		fontWeight: 600,
		display: 'flex',
		alignItems: 'center',

		':is([data-state="active"])': {
			// lighter than colors.primary.light
			background: '#F1F7FF',
			backgroundOpacity: 0.1,
			color: colors.primary.main,
		},
	},
	tabContentContainer: {
		borderLeft: `1px solid ${colors.border.main}`,
		paddingLeft: spacing.md,
	},
	tabContentHidden: {
		display: 'none',
	},
});
